'use server'

import { apiRequest, ApiResponse } from '../request'

export interface Room {
    id: number
    companyId: number
    name: string
    description?: string
    capacity?: number
    resources?: string
    color?: string
    active: boolean
    createdAt: string
    updatedAt: string
}

export interface CreateRoomData {
    companyId: number
    name: string
    description?: string
    capacity?: number
    resources?: string
    color?: string
    active?: boolean
}

export interface UpdateRoomData {
    name?: string
    description?: string
    capacity?: number
    resources?: string
    color?: string
    active?: boolean
}

export async function getRooms(
    companyId?: number
): Promise<ApiResponse<Room[]>> {
    return apiRequest<Room[]>('rooms', {
        params: companyId ? { companyId } : {},
    })
}

export async function getRoom(id: number): Promise<ApiResponse<Room>> {
    return apiRequest<Room>(`rooms/${id}`, {})
}

export async function getRoomsByCompany(
    companyId: number
): Promise<ApiResponse<Room[]>> {
    return apiRequest<Room[]>(`rooms/company/${companyId}`, {})
}

export async function createRoom(
    data: CreateRoomData
): Promise<ApiResponse<Room>> {
    return apiRequest<Room>('rooms', { data }, 'post')
}

export async function updateRoom(
    id: number,
    data: UpdateRoomData
): Promise<ApiResponse<Room>> {
    return apiRequest<Room>(`rooms/${id}`, { data }, 'patch')
}

export async function deleteRoom(id: number): Promise<ApiResponse<void>> {
    return apiRequest<void>(`rooms/${id}`, {}, 'delete')
}

export async function checkRoomAvailability(
    id: number,
    startDate: string,
    endDate: string
): Promise<ApiResponse<{ available: boolean; conflicts: any[] }>> {
    return apiRequest<{ available: boolean; conflicts: any[] }>(
        `rooms/${id}/availability`,
        {
            params: { startDate, endDate },
        }
    )
}

export const ROOM_COLORS = [
    { value: '#3B82F6', label: 'Azul', class: 'bg-blue-500' },
    { value: '#22C55E', label: 'Verde', class: 'bg-green-500' },
    { value: '#EF4444', label: 'Vermelho', class: 'bg-red-500' },
    { value: '#F59E0B', label: 'Amarelo', class: 'bg-amber-500' },
    { value: '#8B5CF6', label: 'Roxo', class: 'bg-violet-500' },
    { value: '#EC4899', label: 'Rosa', class: 'bg-pink-500' },
    { value: '#14B8A6', label: 'Turquesa', class: 'bg-teal-500' },
    { value: '#F97316', label: 'Laranja', class: 'bg-orange-500' },
    { value: '#6366F1', label: 'Indigo', class: 'bg-indigo-500' },
    { value: '#64748B', label: 'Cinza', class: 'bg-slate-500' },
]
